import MobileNav from '../plugins/mobileNav';

const initDetailsPopup = () => {
  const html = document.querySelector('html');
  const activeClass = 'detail-popup-active';
  const activeSizeClass = 'size-popup-active';

  const options = {
    activeClass: 'js-detail-popup-active',
    btnOpenerSelector: '.js-detail-popup-opener',
    hideOnClickOutside: true,
    outSideSelector: '.js-detail-popup',

    onShow: () => {
      html.classList.add(activeClass);
    },
    onHide: () => {
      html.classList.remove(activeClass);
    },
  };

  const popupHolder = document.querySelector('.product-description');
  const popup = new MobileNav(popupHolder, options);
  popup.init();

  const sizeOptions = {
    activeClass: 'js-size-popup-active',
    btnOpenerSelector: '.size-popup-opener',
    hideOnClickOutside: true,
    outSideSelector: '.js-sizes-popup',

    onShow: () => {
      html.classList.add(activeSizeClass);
      popup.hide();
    },
    onHide: () => {
      html.classList.remove(activeSizeClass);
    },

    onInit: (self) => {
      if( $('.js-detail-popup-return').length > 0 ){
        popupHolder.querySelector('.js-detail-popup-return').addEventListener('click', (e) => {
          e.preventDefault();

          self.hide();

          setTimeout(() => {
            popup.show();
          }, 300);
        });
      }
    },
  };

  const sizePopupHolder = document.querySelector('.js-sizes-popup-holder');
  const popupSize = new MobileNav(sizePopupHolder, sizeOptions);
  popupSize.init();
};

export default initDetailsPopup;
